// Do not open app results in the desktop client even if they have deep links
export const EXCLUDED_DEEP_LINK_APPS = ['notion'];
